import React from 'react';
import Shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/local';
import { createLink, _t } from 'utils';
import { ROUTE } from 'constant';
import CreateForm from 'screens/nlb/create';

export const NLBList = ({ networkLoadBalancers = [], history = {}, dcId }) => (
  <Shared.widgets.Section
    sectionTitle={_t('Network Load Balancers')}
    items={networkLoadBalancers}
    createForm={<CreateForm dcId={dcId} />}
    className="-m-t-24"
    createActionType={ACTIONS_TYPES.NETWORK_LOAD_BALANCER.CREATE}
    itemIcon="sitemap"
    setItemDetails={(e) => (
      <span>
        <span>Listener LAN: </span>
        <Shared.utilities.LANBasic lanId={e?.properties?.listenerLan} />
        <span className="m-l-12">Target LAN: </span>
        <Shared.utilities.LANBasic lanId={e?.properties?.targetLan} />
      </span>
    )}
    setItemTitle={(e) => e?.properties?.name}
    itemOnClick={(e) => history.push(createLink(ROUTE.DASHBOARD.NETWORK_LOAD_BALANCER, { dcId, id: e.id }))}
  />
);
